import { createAction, handleActions } from 'redux-actions'

import client from 'common/util/http'

import { selectBrokerOpId } from 'broker/selectors/auth'
import { valueOrNull } from 'broker/util/helper'

const LOAD_BROKER_OPPORTUNITIES_STATS = 'LOAD_BROKER_OPPORTUNITIES_STATS'
const FETCH_BROKER_OPPORTUNITIES_STATS_BEGIN = 'FETCH_BROKER_OPPORTUNITIES_STATS_BEGIN'
const FETCH_BROKER_OPPORTUNITIES_STATS_END = 'FETCH_BROKER_OPPORTUNITIES_STATS_END'

const loadBrokerOpportunitiesStats = createAction(LOAD_BROKER_OPPORTUNITIES_STATS)
const fetchBrokerOpportunitiesStatsBegin = createAction(FETCH_BROKER_OPPORTUNITIES_STATS_BEGIN)
const fetchBrokerOpportunitiesStatsEnd = createAction(FETCH_BROKER_OPPORTUNITIES_STATS_END)


export function fetchBrokerOpportunitiesStats() {
  return async (dispatch, getState) => {
    dispatch(fetchBrokerOpportunitiesStatsBegin())
    const broker_op_id = selectBrokerOpId(getState())
    try {
      const payload = await client.post('broker_opportunities', {
        data: { broker_op_id }
      })

      dispatch(loadBrokerOpportunitiesStats({
        stats: payload
      }))
    } finally {
      dispatch(fetchBrokerOpportunitiesStatsEnd())
    }
  }
}

const makeStats = (payload = {}) => ({
  lead_queries_sent: valueOrNull(payload.lead_queries_sent),
  lead_queries_won: valueOrNull(payload.lead_queries_won),
  lead_queries_clicked: valueOrNull(payload.lead_queries_clicked),
  lead_queries_skipped: valueOrNull(payload.lead_queries_skipped),
  team_average_skip_rate: valueOrNull(payload.team_average_skip_rate),
  team_average_click_time: valueOrNull(payload.team_average_click_time),
  team_average_win_time: valueOrNull(payload.team_average_win_time),
  total_assigned: valueOrNull(payload.total_assigned),
  active_assigned: valueOrNull(payload.active_assigned),
})

const cleanState = (payload = {}) => ({
  stats: makeStats(payload.stats),
  loading: false
})

export default handleActions({
  [LOAD_BROKER_OPPORTUNITIES_STATS]: (state, { payload }) => ({
    ...state,
    stats: makeStats(payload.stats)
  }),
  [FETCH_BROKER_OPPORTUNITIES_STATS_BEGIN]: state => ({
    ...state,
    loading: true
  }),
  [FETCH_BROKER_OPPORTUNITIES_STATS_END]: state => ({
    ...state,
    loading: false
  })
}, cleanState())
